module.exports = __webpack_public_path__ + "img/next_level_section.c4d048b9.png";